import React from "react";

export function WarningStudyPeriode({ student }) {
  const current_program = student?.program?.id || "";
  const current_semester = student?.semester || 0;
  const maxSemesterBachelor = 14;
  const maxSemesterMaster = 8;

  if (
    current_program === 1 &&
    (current_semester === 13 || current_semester === 14)
  ) {
    return (
      <AlertWarning
        title={"Study Period Warning!"}
        message={`Your remaining study period is 
            ${maxSemesterBachelor - current_semester} semesters. Please consult
            your counselor to plan your study completion and simulate your
            CGPA/GPA targets for this semester.`}
      />
    );
  }

  if (current_program === 1 && current_semester > 14) {
    return (
      <AlertWarning
        title={"Study Period Warning!"}
        message={`We would like to inform you that your study period has gone beyond the
          maximum duration of 14 semesters. Please contact the Academic Office
          (AOO) for further assistance.`}
      />
    );
  }

  if (
    current_program === 2 &&
    (current_semester == 7 || current_semester === 8)
  ) {
    return (
      <AlertWarning
        title={"Study Period Warning!"}
        message={`Your remaining study period is ${maxSemesterMaster - current_semester}
          semesters. Please consult your counselor to plan your study completion
          and simulate your CGPA/GPA targets for this semester.`}
      />
    );
  }

  if (current_program === 2 && current_semester > 8) {
    return (
      <AlertWarning
        title={"Study Period Warning!"}
        message={`We would like to inform you that your study period has gone beyond the
          maximum duration of 8 semesters. Please contact the Academic Office
          (AOO) for further assistance.`}
      />
    );
  }

  return "";
}

export const AlertWarning = ({ title, message }) => {
  return (
    <div
      className="alert alert-custom alert-danger shadow fade show"
      role="alert"
    >
      <div className="alert-icon">
        <i className="flaticon-warning"></i>
      </div>
      <div className="alert-text d-flex flex-column">
        <h3 className="alert-heading">{title}</h3>
        <p className="font-size-lg mb-0 text-justify">{message}</p>
      </div>
    </div>
  );
};
